module.exports = __webpack_public_path__ + "static/img/password.edb96aed.svg";